import Header from "../../Header";
import {useEffect, useState} from "react";
import {Payee} from "../../Types/Payee";
import {deleteMyPayeeAccount, getMyPayeeAccount, setMyDefaultPayeeAccount} from "../../API/PayeeManager";
import tableStyle from "../../General CSS/Table.module.css";
import {useNavigate} from "react-router-dom";

export default function AccountEditor() {
    const [payee, setPayee] = useState<Payee | null>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const navigate = useNavigate();

    useEffect(() => {
        getMyPayeeAccount()
            .then(response => {
                setPayee(response);
            })
            .catch(err => setError(err.message || "Unknown Error"))
            .finally(() => setLoading(false));
    }, []);

    const setDefault = (uid: string) => {
        setMyDefaultPayeeAccount(uid)
            .then(() => {
                setPayee((prev) => {
                    if (!prev) return prev;
                    return {
                        ...prev,
                        accounts: prev.accounts.map((account) => {
                            if (account.payeeAccountUid === uid) {
                                return {
                                    ...account,
                                    defaultAccount: true
                                }
                            } return {
                                ...account,
                                defaultAccount: false
                            };
                        }),
                    };
                });
            })
            .catch((err: any) => alert(err.message || "Unknown Error"));
    }

    const handleDelete = (uid: string) => {
        deleteMyPayeeAccount(uid)
            .then(() => {
                setPayee((prev) => {
                    if (!prev) return prev;
                    return {
                        ...prev,
                        accounts: prev.accounts.filter(account => account.payeeAccountUid !== uid)
                    }
                });
            })
            .catch((err: any) => alert(err.message || "Unknown Error"));
    };

    const addAccount = () => {
        navigate("/account/my-account/add")
    }

    return (
        <>
            <Header page={"Edit My Accounts"} returnLink={"/account/my-account"}/>
            <div className="content">
                { loading ? (
                    <p></p>
                ) : error ? (
                    <p>{error}</p>
                ) : payee ? (
                    <div className={tableStyle.table}>
                        <h2>My Accounts</h2>
                        {payee.accounts.map(account => (
                            <>
                            <table key={account.payeeAccountUid}>
                                <tbody>
                                <tr>
                                    <td>Name On Account</td>
                                    <td>{payee.name}</td>
                                </tr>
                                <tr>
                                    <td>Sort Code</td>
                                    <td>{account.bankIdentifier}</td>
                                </tr>
                                <tr>
                                    <td>Account Number</td>
                                    <td>{account.accountIdentifier}</td>
                                </tr>
                                <tr>
                                    <td>Account Description</td>
                                    <td>{account.description}</td>
                                </tr>
                                <tr>
                                    <td>Is default account?</td>
                                    <td>{account.defaultAccount ? "Yes" : "No"}</td>
                                </tr>
                                </tbody>
                            </table>
                                {!account.defaultAccount ? (
                                    <>
                                        <button onClick={() => setDefault(account.payeeAccountUid)}>Set as default</button>
                                        <button onClick={() => handleDelete(account.payeeAccountUid)} className="delete">Delete</button>
                                    </>
                                ) : (<></>)
                                }
                            </>
                        ))}
                        <button onClick={addAccount} style={{ display: "block", marginTop: "1rem" }}>Add an account</button>
                    </div>
                ) : <h3>No account found</h3>
                }
            </div>
            </>
    )
}